export default __webpack_public_path__ + "static/media/Robot_03.59c31134.png";